import { render, staticRenderFns } from "./ProductionSnapshot.vue?vue&type=template&id=3beb0a6a"
import script from "./ProductionSnapshot.vue?vue&type=script&lang=js"
export * from "./ProductionSnapshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports